export default __webpack_public_path__ + "static/tennis-a2cab2c7714701d861b832b534088997.svg";